import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type MarketplaceConnection, type SaaSTenant } from '../../api/saas';

export function MarketplaceManagerPage() {
  const [tenants, setTenants] = useState<SaaSTenant[]>([]);
  const [connections, setConnections] = useState<MarketplaceConnection[]>([]);
  const [selected, setSelected] = useState('');

  useEffect(() => { void saasApi.tenants().then(setTenants).catch(() => {}); }, []);
  useEffect(() => {
    if (!selected) return;
    void saasApi.marketplaces(selected).then(setConnections).catch(() => setConnections([]));
  }, [selected]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Marketplace Manager</h1>
      <select className="mt-4 rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" value={selected} onChange={(e) => setSelected(e.target.value)}>
        <option value="">Select tenant</option>
        {tenants.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
      <ul className="mt-4 divide-y rounded-lg border dark:border-slate-700">
        {connections.map((c) => (
          <li key={c.id} className="flex justify-between px-4 py-3 text-sm">
            <span className="font-medium capitalize">{c.marketplace}</span>
            <span className={c.status === 'connected' ? 'text-green-600' : 'text-slate-500'}>{c.status}</span>
          </li>
        ))}
        {selected && connections.length === 0 && <li className="px-4 py-6 text-center text-slate-500">No marketplace connections</li>}
      </ul>
    </div>
  );
}
